'use client';
// External Libs
import { ReactElement } from 'react';
import clsx from 'clsx';
import { ToggleButtonGroup as ToggleButtonGroupMui } from '@mui/material';
// Lib
import { ToggleButtonGroupProps } from './toggle-button-group-interfaces';
import { columnDirectionStyles, standAloneButtonsStyles } from './toggle-button-group.styles';

const ToggleButtonGroup = (props: ToggleButtonGroupProps): ReactElement => {
  const { standaloneButtons, direction, ...muiToggleButtonProps } = props;
  const isColumnDirection = direction == 'column';

  return (
    <ToggleButtonGroupMui
      className={clsx(standaloneButtons && standAloneButtonsStyles, isColumnDirection && columnDirectionStyles)}
      {...muiToggleButtonProps}
    />
  );
};

export default ToggleButtonGroup;
